import { render, staticRenderFns } from "./StationEventEditor.vue?vue&type=template&id=6184a971&scoped=true&"
import script from "./StationEventEditor.vue?vue&type=script&lang=js&"
export * from "./StationEventEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184a971",
  null
  
)

/* custom blocks */
import block0 from "./StationEventEditor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6184a971')) {
      api.createRecord('6184a971', component.options)
    } else {
      api.reload('6184a971', component.options)
    }
    module.hot.accept("./StationEventEditor.vue?vue&type=template&id=6184a971&scoped=true&", function () {
      api.rerender('6184a971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/StationEventEditor.vue"
export default component.exports